import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {DownloadRequestItem} from '../../core/_models'
import {CustomHeader} from './CustomHeader'

type Props = {
  column: ColumnInstance<DownloadRequestItem>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <CustomHeader tableProps={{column}} title={column.Header} className='min-w-125px' />
    ) : (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    )}
  </>
)

export {CustomHeaderColumn}
